<template>
  <div class="section-main__warp inspection-wrap inspection-record-page">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="status" slot-scope="scope">
        <span v-if="scope.row.status === '1'" style="color: yellow">{{
          statusFormatter(scope.row)
        }}</span>
        <span v-if="scope.row.status === '2'" style="color: #00e8bb">{{
          statusFormatter(scope.row)
        }}</span>
        <span v-if="scope.row.status === '3'" style="color: #9b9b9b">{{
          statusFormatter(scope.row)
        }}</span>
        <span v-if="scope.row.status === '4'" style="color: red">{{
          statusFormatter(scope.row)
        }}</span>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <record-detail ref="detail"></record-detail>
  </div>
</template>
<script>
import { api } from "../api";
import tableOption from "../const/recordOption";
import recordDetail from "../components/recordDetail";
import utils from "@src/common/utils";
import { Dic, Bus } from "$utils";
export default {
  components: {
    recordDetail,
  },
  data() {
    return {
      tableData: [],
      checkedAssets: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      searchParams: {},
      option: tableOption(this),
      rowInfo: {},
    };
  },
  mounted() {
    this.getList();
  },
  created() {},
  methods: {
    statusFormatter(data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return "待巡检";
        case 2:
          return "执行中";
        case 3:
          return "已完成";
        case 4:
          return "已超时";
        default:
          return data.status;
      }
    },
    handleSearchReset() {
      this.getList();
    },
    getList() {
      const params = {
        status: this.searchParams.status,
        taskName: this.searchParams.taskName, //'巡检计划名称'
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      this.$fetch(api.inspectionPlan.queryTaskRecordList, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.tableData = response.returnObj
              ? Object.freeze([...response.returnObj.list])
              : [];
            this.page.total = response.returnObj ? response.returnObj.total : 0;
            this.$refs.crud.selectClear();
          }
        }
      );
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSearchChange(param) {
      this.searchParams = param;
      this.page.currentPage = 1;
      this.getList();
    },
    handleView(row) {
      console.log("记录信息", row);
      this.$refs.detail.open(row);
    },
    handleEdit(row, index) {
      this.rowInfo = row;
      this.$refs.crud.rowEdit(row, index);
    },
    handleDel(row) {
      const params = {
        planCode: row.planCode, //'巡检计划code'
      };
      this.$confirm("您确定删除该巡检计划吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.inspectionPlan.deleteInspectionPlan, params).then(
          (response) => {
            if (response && response.success) {
              this.$message.success(response.msgContent);
              this.getList();
            } else {
              this.$message.error(response.msgContent);
            }
          }
        );
      });
    },
    handleUpdateStatus(row) {
      this.$confirm(
        `确定要${row.status == "1" ? "启动" : "禁止"}此任务吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            planCode: row.planCode, //'巡检计划code'
            status: row.status, //状态 1：启动,2：禁止
          };
          this.$fetch(api.inspectionPlan.startOrStopPlan, params).then(
            (res) => {
              if (res.success) {
                this.$message({
                  showClose: false,
                  message: `巡检任务${
                    row.status === "1" ? "启动" : "禁止"
                  }成功`,
                  type: "success",
                  duration: 2000,
                });
                this.getList();
              }
            }
          );
        })
        .catch(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "取消成功！",
            duration: 2000,
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "../style/inspectionPlan.scss";
</style>
